module.exports = __webpack_public_path__ + "img/orange-stripe-lily.bcc2528d.webp";